<div class="title">
  <div class="coldx ">
    <h4>{{companiesDepartmentSelected ? 'Modifica Dipartimento' : 'Crea dipartimento'}}</h4>
  </div>
</div>

<form [formGroup]="form" (click)="errorCheck()">

    <div class="row">
      <div class="col-sm-6">
        <div class="form-group"> <label for="">Nome dipartimento</label> <span _ngcontent-c10="" class="mandatory ">*</span>
          <input placeholder="Inserisci nome dipartimento" [(ngModel)]="typeSelected.name" formControlName="name" autocomplete="organization" id=""
            type="text" class="form-control">
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group"> <label for="">Descrizione dipartimento</label> <span _ngcontent-c10=""
            class="mandatory ">*</span>
          <input placeholder="Inserisci descrizione dipartimento " [(ngModel)]="typeSelected.description"
            formControlName="description" id="" type="text" class="form-control">

        </div>
      </div>
    </div>

  <div class="row">
    <div class="col-sm-6">
      <div class="form-group">
        <label for="company">Società</label> <span class="mandatory ">*</span>
        <select (ngModelChange)="changeCompany($event)" class="form-control" type="text" formControlName="company">
          <option [ngValue]="null">Seleziona una società</option>
          <option *ngFor="let company of companiesList " [title]="company.name" [ngValue]="company"> {{company.name}}
          </option>
        </select>
      </div>
    </div>

    <div class="col-sm-6" *ngIf="companySelected">
      <div class="form-group">
        <label for="parent">Associa ad un altro dipartimento</label>
        <select (ngModelChange)="changeDepartment($event)" class="form-control" type="text" formControlName="parent">
          <option [ngValue]="null">Seleziona un dipartimento</option>
          <option *ngFor="let department of parentDepartments" [title]="department.name" [ngValue]="department">
            {{department.name}}
          </option>
        </select>
      </div>
    </div>

  </div>






  <div class="form-row" *ngIf="formEdit">
    <div class="col-sm-6 col-sm-offset-6">
      <div class="form-check">
        <label for="" class="form-check-label">Abilitata</label>
        <span _ngcontent-c10="" class="mandatory">*</span>
        <input formControlName="enabled" id="" type="checkbox" class="form-check-input" style="margin-left: 10px">
      </div>
    </div>
  </div>

  <p class="col-md-12 mandatory"><em>* Campi obbligatori</em></p>
  <div class="form-row">
    <div class="col-sm-6 col-xs-12"></div>

    <div class="col-sm-3 col-xs-6"> <button type="button" class="btn btn-outline-secondary btn-block" (click)="formReset()">Reset</button>
    </div>
    <div *ngIf="!formEdit" class="col-sm-3 col-xs-6"> <button type="submit" (click)="onSave()" [disabled]="!form.valid"
        class="btn btn-primary btn-block   ">{{companiesDepartmentSelected ? 'Salva' : 'Crea'}}</button> </div>
  </div>

</form>
